/* WATASHI — comportamenti leggeri delle sezioni wtsh-* */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Rivelazione progressiva allo scroll */
  const observer =
    'IntersectionObserver' in window && !reduceMotion.matches
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;

  const reveal = (root = document) => {
    root.querySelectorAll('[data-wtsh-reveal]:not(.is-visible)').forEach((el) => {
      if (observer) observer.observe(el);
      else el.classList.add('is-visible');
    });
  };

  /* Video hero: niente autoplay se l'utente preferisce meno movimento */
  const handleVideos = (root = document) => {
    root.querySelectorAll('[data-wtsh-autoplay] video').forEach((video) => {
      if (reduceMotion.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });
  };

  /* Pannelli <dialog> (guida taglie): apertura, chiusura su backdrop, ritorno del focus */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-wtsh-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.wtshDialogOpen);
      if (!dialog) return;
      dialog.wtshTrigger = opener;
      dialog.showModal();
      document.documentElement.classList.add('wtsh-dialog-open');
      return;
    }

    const closer = event.target.closest('[data-wtsh-dialog-close]');
    const dialog = closer ? closer.closest('dialog') : event.target.closest('dialog.wtsh-dialog');
    if (!dialog) return;
    /* Click sul backdrop: il target è il dialog stesso */
    if (closer || event.target === dialog) dialog.close();
  });

  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('wtsh-dialog')) return;
      document.documentElement.classList.remove('wtsh-dialog-open');
      dialog.wtshTrigger?.focus();
    },
    true
  );

  /* Nastro: animazione in pausa fuori schermo (meno lavoro durante lo scroll) */
  const tickerObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          for (const entry of entries) entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        })
      : null;

  const watchTickers = (root = document) => {
    if (!tickerObserver) return;
    for (const ticker of root.querySelectorAll('.wtsh-ticker')) tickerObserver.observe(ticker);
  };

  const init = (root) => {
    watchTickers(root);
    reveal(root);
    handleVideos(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  /* Editor del tema: reinizializza le sezioni ricaricate */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
